// src/features/wbs/editor/hooks/useWbsKeyboard.ts
import { useEffect } from 'react';

type Handlers = {
    onMoveUp: () => void;
    onMoveDown: () => void;
    // onIndent: () => void;
    // onOutdent: () => void;
    // onAddSibling: () => void;
    // onAddChild: () => void;
    // onDelete: () => void;
};

export function useWbsKeyboard(enabled: boolean, h: Handlers) {
    useEffect(() => {
        if (!enabled) return;
        const onKey = (e: KeyboardEvent) => {
            const alt = e.altKey;
            if (!alt) return;
            switch (e.key) {
                case 'ArrowUp':
                    e.preventDefault();
                    h.onMoveUp();
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    h.onMoveDown();
                    break;
                // case 'ArrowRight':
                //     e.preventDefault();
                //     h.onIndent();
                //     break;
                // case 'ArrowLeft':
                //     e.preventDefault();
                //     h.onOutdent();
                //     break;
                // case 'Enter':
                //     e.preventDefault();
                //     h.onAddSibling();
                //     break;
                // case 'N':
                // case 'n':
                //     e.preventDefault();
                //     h.onAddChild();
                //     break;
                // case 'Delete':
                //     e.preventDefault();
                //     h.onDelete();
                //     break;
            }
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [enabled, h]);
}
